import { useMemo } from "react";

const useUrlParams = (paramKeys: string[]) => {
  return useMemo(() => {
    const params = new URLSearchParams(window.location.search);
    const result: Record<string, string | null> = {};
    paramKeys.forEach((key) => {
      result[key] = params.get(key);
    });
    return result;
  }, [paramKeys]);
};

export default useUrlParams;
